export default "__VITE_ASSET__a03c63aa__"